import React from "react";
import { graphql } from "gatsby"
import Block from "../../Block";

class FaqBlock extends Block {
  render() {
    const { block } = this.props;

    const text = block.originalContent
                       .replace(/<br\/>/ig, "\n")
                       .replace(/(<([^>]+)>)/ig, '')
                       .replace(/\n/ig, '<br />')

    return <p dangerouslySetInnerHTML={{ __html: text }} />
  }
}

class FaqBlockFactory {
  get type() {
    return "yoast/faq-block";
  }

  create(props) {
    return <FaqBlock {...props} />;
  }
}

export default FaqBlockFactory;
